import { externalApi } from '../../shared/config/axiosConfig';
import { logDebug } from '../../shared/config/globalFunctions';

/**
 * @typedef {import('../../../global').ObjectJSON_1_1_2} ObjectJSON_1_1_2
 */

/**
 *
 * @returns
 */
export const GetFile = async (guid, type) => {
  let fileType = type ? type?.toLowerCase() : 'json';
  const response = await externalApi({
    method: 'GET',
    url: '/file/get',
    params: {
      filename: guid + '.' + fileType,
    },
  });
  return response.data;
};

/**
 * Gets a file's Json from API. Used to render the file in the viewer.
 * @param {string} guid The file's GUID
 * @param {(progress: number) => any} onProgress
 * @param {AbortSignal} abortSignal
 * @returns {Promise<ObjectJSON_1_1_2>} The json content of the object's file
 */
export const GetFileJsonFromAPI = async (
  guid,
  onProgress = null,
  abortSignal
) => {
  const filename = guid + '.json';

  const response = await externalApi({
    method: 'GET',
    url: '/file/get',
    params: {
      filename,
    },
    signal: abortSignal,
    onDownloadProgress: onProgress
      ? (progressEvent) => {
          const total = progressEvent.total;
          const loaded = progressEvent.loaded ?? 0;
          if (!total || !Number.isFinite(total) || total <= 0) return;
          onProgress(Math.min(1, Math.max(0, loaded / total)));
        }
      : null,
  });

  return response.data;
};
